import { render, staticRenderFns } from "./CosmoClawHome.vue?vue&type=template&id=fbecf3f4&scoped=true"
import script from "./CosmoClawHome.vue?vue&type=script&lang=js"
export * from "./CosmoClawHome.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawHome.vue?vue&type=style&index=0&id=fbecf3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbecf3f4",
  null
  
)

export default component.exports